"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numBetween = void 0;
const numBetween = (currentVal, a, b, inclusive) => {
    const min = Math.min.apply(Math, [a, b]);
    const max = Math.max.apply(Math, [a, b]);
    return inclusive
        ? currentVal >= min && currentVal <= max
        : currentVal > min && currentVal < max;
};
exports.numBetween = numBetween;
